<script>
    export let txs
</script>
{#if txs}
    <h2>Transactions</h2>
    <table>
        <thead>
        <tr>
            <th>Id</th>
            <th>Type</th>
            <th>Amount</th>
            <th>Currency</th>
            <th>CorrelationId</th>
            <th>ExternalTxId</th>
            <th>CreatedId</th>
        </tr>
        </thead>
        <tbody>
        {#each txs as tx}
            <tr>
                <td>
                    {tx.id}
                </td>
                <td>
                    {tx.type}
                </td>
                <td>
                    {tx.amount}
                </td>
                <td>
                    {tx.currency}
                </td>
                <td>
                    {tx.correlationId}
                </td>
                <td>
                    {tx.externalTxId}
                </td>
                <td>
                    {tx.createdAt}
                </td>
            </tr>
        {/each}
        </tbody>
    </table>
{/if}
<style>
    table {
        width: 100%;
        row-gap: 2px;
    }

    td {
        border: solid 1px;
        font-size: 0.8rem;
    }
</style>
